import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const CatalogSchema_ = z.object({
  catalogId: z.string(),
  catalogTitle: z.string(),
  catalogType: z.enum(["MARKET", "COMPANY_LOCATION"]),
  priceListCurrency: z.string(),
  markets: z.array(z.object({ id: z.string(), name: z.string() })).optional(),
  companyLocations: z
    .array(z.object({ id: z.string(), name: z.string() }))
    .optional(),
});

export const CatalogSchema: z.ZodType<CatalogSchema> = CatalogSchema_;
export interface CatalogSchema extends z.infer<typeof CatalogSchema_> {}

export const getShopifyCatalogs = {
  name: "getShopifyCatalogs" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ catalogs: z.array(CatalogSchema) }),
};
